/**
 * Telegram storefront settings API client (BFF: `/api/v1/store/settings/telegram`).
 *
 * Covers the Telegram bot / Mini App settings plus a bot connection test. The bot
 * token is write-only on update and never returned.
 */
import { apiClient } from '@/shared/api';
import type {
  TelegramSettings,
  TestConnectionResult,
  UpdateTelegramSettingsRequest,
} from '../model/settingsTypes';

const BASE = '/api/v1/store/settings/telegram';

export const getTelegramSettings = async (): Promise<TelegramSettings> =>
  (await apiClient.get<TelegramSettings>(BASE)).data;

export const updateTelegramSettings = async (
  body: UpdateTelegramSettingsRequest,
): Promise<TelegramSettings> => (await apiClient.put<TelegramSettings>(BASE, body)).data;

export const testTelegramConnection = async (): Promise<TestConnectionResult> =>
  (await apiClient.post<TestConnectionResult>(`${BASE}/test-connection`)).data;
